import gql from "graphql-tag";

export default gql`
  fragment LockableCommentFields on LockableComment {
    isLocked
    lockedBy {
      _id
      fullName
    }
  }
`;
